// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b372326e","899":"883c86ff"}[chunkId] + ".chunk.js";
};